import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 16v-8l-2 2","key":"svg-0"}],["path",{"d":"M13 16l4 -4","key":"svg-1"}],["path",{"d":"M17 16l-4 -4","key":"svg-2"}]]

const IconMultiplier1x = createReactComponent('outline', 'multiplier-1x', 'Multiplier1x', __iconNode);

export default IconMultiplier1x;